import { PropType, computed, defineComponent } from 'vue'

import { CsCheckbox, CsRadioButton } from '@sunrise/components'
import { createUUID } from '@sunrise/components/src/utils/uuid'

import { SearchRequestKeys } from '../../ts/mapper/CmsPropertyMapper.enum'
import { FilterId } from '../../ts/service/realEstateService.enum'
import { FilterType, SearchRequestValues } from '../../ts/service/realEstateService.interface'
import { useMailAgentStore } from '../../ts/store/mailAgentStoreModule/mailAgentStoreModule'
import { useResultListStore } from '../../ts/store/resultListStoreModule/resultListStoreModule'
import { updateSearchParams } from '../../ts/utils/searchListUtils'

export default defineComponent({
    name: 'MsFilterEnhanced',
    components: { CsCheckbox, CsRadioButton },
    props: {
        searchFilters: {
            type: Object as PropType<FilterType>,
            required: true,
        },
    },
    setup(props) {
        const { searchParams, resetPage } = useResultListStore()
        const { tags } = useMailAgentStore()
        const radioName = createUUID('radio-group-')

        const filterState: any = computed(() => ({
            [SearchRequestKeys.EQUIPMENT_ID]: searchParams.eqid?.map((num) => num.toString()),
            [SearchRequestKeys.FURNISHING_ID]: searchParams.furnid?.toString(),
            [SearchRequestKeys.ESTATE_CATEGORY]: searchParams.ecat?.map((num) => num.toString()),
            [SearchRequestKeys.ESTATE_POSITION]: searchParams.epos?.map((num) => num.toString()),
        }))

        function onUpdateModelValueCheckbox(newValue: string, paramKey: SearchRequestValues, tag: string): void {
            const mailAgentStoreKey = determineMailAgentStoreKey(paramKey)

            resetPage()
            updateSearchParams({ [paramKey]: newValue })
            tagExistInMailAgent(tag, mailAgentStoreKey)
                ? removeTagFromMailAgentStore(tag, mailAgentStoreKey)
                : pushTagToMailAgentStore(tag, mailAgentStoreKey)
        }

        function onUpdateModelValueRadio(newValue: string, paramKey: SearchRequestValues, tag: string): void {
            resetPage()
            updateSearchParams({ [paramKey]: Number(newValue) })

            const excludedFurnLabel = props.searchFilters.values[0].label
            if (tag !== excludedFurnLabel) {
                tags['furnishing'] = tag
            } else {
                tags['furnishing'] = ''
            }
        }

        function tagExistInMailAgent(label: string, mailAgentStoreKey: string): boolean {
            return tags[mailAgentStoreKey]?.includes(label)
        }

        function removeTagFromMailAgentStore(label: string, mailAgentStoreKey: string): void {
            tags[mailAgentStoreKey] = (tags[mailAgentStoreKey] as string[]).filter(
                (filterLabel) => filterLabel !== label,
            )
        }

        function pushTagToMailAgentStore(label: string, mailAgentStoreKey: string): void {
            ;(tags[mailAgentStoreKey] as string[]).push(label)
        }

        function determineMailAgentStoreKey(paramKey: string): string {
            return paramKey === SearchRequestKeys.EQUIPMENT_ID ? 'equipment' : 'category'
        }

        return {
            onUpdateModelValueCheckbox,
            onUpdateModelValueRadio,
            filterState,
            FilterId,
            SearchRequestKeys,
            searchParams,
            radioName,
        }
    },
})
